import { Injectable, EventEmitter } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UrlSyncService {
  // Emits the current URL when it changes without triggering full navigation
  urlChanged = new EventEmitter<string>();
}
